/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';
import { renameProduct } from 'shared/helpers/renameProduct';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces the product name in text with the installation name from global
   * config. A troca em si vive em `shared/helpers/renameProduct` — mesma regra
   * usada na árvore de mensagens do dashboard, para as duas não divergirem.
   * @param {string} text - The text to process
   * @returns {string} - Text with the product name replaced
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    if (!installationName) return text;

    return renameProduct(text, installationName);
  };

  return {
    replaceInstallationName,
  };
}
